<template>
	<!-- Skip Links for Keyboard Navigation — teleported before v-main for first-focus order -->
	<Teleport to="#skip-links-portal">
		<a href="#main-content" class="skip-link" @click.prevent="() => { const el = document.getElementById('main-content'); if (el) el.focus(); }">Skip to main content</a>
		<a href="#products-earn" class="skip-link" @click.prevent="() => { const el = document.getElementById('products-earn'); if (el) el.focus(); }">Skip to products you can earn rewards on</a>
		<a href="#products-spend" class="skip-link" @click.prevent="() => { const el = document.getElementById('products-spend'); if (el) el.focus(); }">Skip to products you can spend rewards on</a>
	</Teleport>
	
	<div class="bg-color-granite pb-10" role="main" aria-label="Eligible Products Information">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
				alt="RISE Eligible Products Program Banner"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Eligible Products" /></h1>
			</div>		
 		</div>

        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 tx-color-white" :class="{'bg-color-teal-900': systemStore.systemView === 'Distributor', 'bg-color-dell-blue': systemStore.systemView !== 'Distributor'}" >
                    <v-col cols="1"></v-col>
                    <v-col cols="10" class="d-flex flex-column justify-center w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                        <v-row class="mb-1">
                            <LanguagePlaceholder is-html
                            default-text="Earn competitive $ per box rewards on qualifying purchases and unlock higher RISE multipliers as you reach defined unit thresholds." />
                        </v-row>
                    </v-col>
                    <v-col cols="1"></v-col>
                </v-row>
            </div>
        </div>
        <section class="bg-color-granite w-auto h-100 my-2 mx-10">
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100">
            <v-col cols="12" md="1" class="bg-color-quartz pa-2 pa-md-5"></v-col>
            <v-col cols="12" md="10" class="d-flex justify-start flex-column w-100 my-2 my-md-5 pb-5 pb-md-10 tx-font-bold bg-color-white px-2 px-md-0">  
                <div class="ma-0 pa-3 pa-md-5 mb-5 mb-md-10 bg-color-cobalt tx-color-white tx-font-normal tx-font-size18">
                    <LanguagePlaceholder is-html
                                            default-text="​​​​​​Select your preferred quarter to display eligible products from previous quarters." />
                </div>
                <v-select v-model="selectedQuarter" class="w-100 w-md-25 ps-0 ps-md-14 mb-2"
                    :items="quarters" variant="outlined"
                    label="Select Quarter"
                    @update:menu="(val) => quarterMenuOpen = val"
                    :aria-describedby="'quarter-help'"
                    id="quarter-select">
                    <template v-slot:label>
                        <LanguagePlaceholder
                            is-html
                            default-text="Select Quarter" />
                    </template>
                </v-select>
                <div aria-live="polite" aria-atomic="true" class="sr-only">
                    {{ selectedQuarter ? `Selected quarter: ${selectedQuarter}` : '' }}
                </div>
            </v-col>
            <v-col cols="12" md="1" class="bg-color-quartz"></v-col>
            </v-row>
        </section>
        <div class="bg-color-granite w-auto h-100 my-2 mx-10" id="main-content">
            <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="5" class="d-flex justify-start w-100 pa-0 py-5 tx-font-bold bg-color-quartz" id="products-earn">  
                    <v-container>

                        <div class="w-100 my-5">
                            <div class="bg-color-quartz w-100 my-2">
                                <h2>
                                    Products that you can <b> EARN </b> rewards on
                                </h2>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="isLatestQuarterLayout && selectedQuarter != 'Q3 FY27'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY27Q4</b> (31 October 2026 – 29 January 2027) and <b style='font-weight: bold'> redeemable in FY28Q1. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="Please find the link to the Eligible Products list, " />
                                <a href="https://www.dellpartnerincentives.com/resources/RISE%20Eligible%20Products%20List.pdf" target="_blank" rel="noopener noreferrer" style="text-decoration: underline;" aria-label="Eligible Products list PDF, opens in a new tab">click here</a>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="selectedQuarter == 'Q3 FY27'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY27Q3</b> (1 Aug 2026 - 30 Oct 2026) and <b style='font-weight: bold'> redeemable in FY27Q4. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')" aria-label="learn more about RISE rewards earnings and payments on the About RISE page">click here</a>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="selectedQuarter == 'Q1 FY27'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY27Q1</b> (31 January 2026 - 1 May 2026) and <b style='font-weight: bold'> redeemable in FY27Q2. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')" aria-label="learn more about RISE rewards earnings and payments on the About RISE page">click here</a>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="selectedQuarter == 'Q4 FY26'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY26Q4</b> (1 November 2025 – 30 January 2026) and <b style='font-weight: bold'> redeemable in FY27Q1. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')" aria-label="learn more about RISE rewards earnings and payments on the About RISE page">click here</a>
                            </div>
                            <!-- <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="currentQuarter == selectedQuarter || selectedQuarter == 'Q4 FY26'">
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')">click here</a>
                            </div> -->
                        </div>

                        <v-expansion-panels v-model="panel" tile variant="accordion" class="my-3" role="group" aria-label="Products you can earn rewards on">
                            <v-expansion-panel v-if="eligibleProducts.pcDisplayPeripheralProducts?.length">

                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}" 
                                        aria-label="Expand PCS+ Displays+ Peripherals rewards information"
                                        tabindex="0">
                                        <LanguagePlaceholder default-text="PCS+ DISPLAYS+ PERIPHERALS" />
                                    </v-expansion-panel-title>
                            

                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <LanguagePlaceholder is-html default-text="Rewards Overview <p style=&quot;font-size: 70%&quot;>(<b>You cannot earn rewards on Snapdragon-based configurations -  Qualcomm</b>)</p>" v-if="isLatestQuarterLayout"/>
                                                <LanguagePlaceholder is-html default-text="Rewards Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD and Qualcomm-powered configurations are not eligible on PC purchases</b>)</p>" v-else/> 
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact" aria-label="PCS+ Displays+ Peripherals rewards table">
                                                    <caption class="sr-only">Table showing rewards per box and multiplier eligibility for PCs, Displays, and Peripherals products</caption>
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="PCs+ Displays+ Peripherals (SnS: Stock & Sell Only)" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="$ Rewards Per Box" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Counts Towards  Rewards Multiplier" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(i, idx) in eligibleProducts.pcDisplayPeripheralProducts" :key="'pc-' + idx + '-' + i.productDescription">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Qualcomm
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Excluded
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                No
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>

                            <v-expansion-panel v-if="hasServerPlusProducts">
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}" 
                                        aria-label="Expand Server+ rewards information"
                                        tabindex="0">
                                        <LanguagePlaceholder default-text="Server+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >                         
                                                <LanguagePlaceholder is-html default-text="Rewards Overview" v-if="isLatestQuarterLayout"/>
                                                <LanguagePlaceholder is-html default-text="Rewards Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD is not eligible on Server purchases</b>)</p>" v-else/>                                  
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact" aria-label="Server+ rewards table">
                                                    <caption class="sr-only">Table showing rewards per box and multiplier eligibility for Server+ products</caption>
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="Server+ SNS (Stock and Sell all) & B2B (Smart selection only)" />
                                                                
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="$ Rewards Per Box" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Counts Towards  Rewards Multiplier" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style="background-color: #CBEEFF;">
                                                            <td>
                                                                <LanguagePlaceholder default-text="Stock & Sell and Back to Back" />
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr v-for="(i, idx) in eligibleProducts.serverPlusB2BProducts" :key="'server-b2b-' + idx + '-' + i.productDescription">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Qualcomm
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Excluded
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                No
                                                            </td>
                                                        </tr>
                                                        <tr style="background-color: #CBEEFF;">
                                                            <td>
                                                                <LanguagePlaceholder default-text="Stock & Sell Only" />
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr v-for="(i, idx) in eligibleProducts.serverPlusSnSProducts" :key="'server-sns-' + idx + '-' + i.productDescription">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Qualcomm
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Excluded
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                No
                                                            </td>
                                                        </tr>
                                                        <tr style="background-color: #CBEEFF;">
                                                            <td>
                                                                <LanguagePlaceholder default-text="Back to Back Smart Selection" />
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr v-for="(i, idx) in eligibleProducts.serverPlusB2BSmartSelectionProducts" :key="'server-b2b-smart-' + idx + '-' + i.productDescription">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Qualcomm
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Excluded
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                No
                                                            </td>
                                                        </tr>
                                                        <tr style="background-color: #CBEEFF;">
                                                            <td>
                                                                <LanguagePlaceholder default-text="Back to Back Only" />
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr v-for="(i, idx) in eligibleProducts.serverPlusB2BOnlyProducts" :key="'server-b2b-only-' + idx + '-' + i.productDescription">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Qualcomm
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Excluded
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                No
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>

                            </v-expansion-panel>

                            <v-expansion-panel v-if="eligibleProducts.networkingSmartSelectionOnly?.length">
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}" 
                                        aria-label="Expand Networking rewards information"
                                        tabindex="0">
                                        <LanguagePlaceholder default-text="NETWORKING" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <LanguagePlaceholder default-text="Rewards Overview" />
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact" aria-label="Networking rewards table">
                                                    <caption class="sr-only">Table showing rewards per box and multiplier eligibility for Networking products</caption>
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Networking (Smart Selection Only)" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="$ Rewards Per Box" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Counts Towards  Rewards Multiplier" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(i, idx) in eligibleProducts.networkingSmartSelectionOnly" :key="'networking-' + idx + '-' + i.productDescription">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Qualcomm
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Excluded
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                No
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>

                            </v-expansion-panel>

                            <v-expansion-panel v-if="eligibleProducts.storagePlusProducts?.length">
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}" 
                                        aria-label="Expand Storage+ rewards information"
                                        tabindex="0">
                                        <LanguagePlaceholder default-text="Storage+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <LanguagePlaceholder default-text="Rewards Overview" />
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact" aria-label="Storage+ rewards table">
                                                    <caption class="sr-only">Table showing rewards per box and multiplier eligibility for Storage+ products</caption>
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Storage+ (Eligible Back to Back (B2B) Smart Selection Offers)" />
                                                                
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="$ Rewards Per Box" />
                                                                
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Counts Towards  Rewards Multiplier" />
                                                                
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(i, idx) in eligibleProducts.storagePlusProducts" :key="'storage-' + idx + '-' + i.productDescription">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Qualcomm
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                Excluded
                                                            </td>
                                                            <td :style="{color:'#FF0000', fontWeight:'bold'}">
                                                                No
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>
                        </v-expansion-panels>
                        
                        </v-container>
                </v-col>
                <v-col cols="5" class="d-flex justify-start w-100 pa-0 py-5 tx-font-bold bg-color-quartz" id="products-spend">
                    <v-container>
                        <div class="w-100 my-5">
                            <div class="bg-color-quartz w-100 my-2">
                                <h2>
                                    Products that you can <b> SPEND </b> rewards on
                                </h2>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="isLatestQuarterLayout && selectedQuarter != 'Q3 FY27'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY27Q3</b> (1 Aug 2026 – 30 Oct 2026) and <b style='font-weight: bold'> redeemable in FY27Q4. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="Please find the link to the SPEND list, " />
                                <a href="https://www.dellpartnerincentives.com/resources/RISE%20Products%20Eligible%20for%20E-voucher%20Spend.pdf" target="_blank" rel="noopener noreferrer" style="text-decoration: underline;" aria-label="SPEND list PDF, opens in a new tab">click here</a>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="selectedQuarter == 'Q3 FY27'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY27Q2</b> (2 May 2026 - 31 July 2026) and <b style='font-weight: bold'> redeemable in FY27Q3. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')" aria-label="learn more about RISE rewards earnings and payments on the About RISE page">click here</a>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="currentQuarter == 'Q1 FY27'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY26Q4</b> (1 November 2025 - 30 January 2026) and <b style='font-weight: bold'> redeemable in FY27Q1. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')" aria-label="learn more about RISE rewards earnings and payments on the About RISE page">click here</a>
                            </div>
                            <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="selectedQuarter == 'Q4 FY26'">
                                <LanguagePlaceholder is-html
                                default-text="<b style='font-size: 18px; font-weight: bolder'>Please note:</b> This applies to rewards earned in <b style='font-weight: bold'>FY26Q3</b> (2 August 2025 - 31 October 2025) and <b style='font-weight: bold'> redeemable in FY26Q4. </b>" />
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')" aria-label="learn more about RISE rewards earnings and payments on the About RISE page">click here</a>
                            </div>
                            <!-- <div class="bg-color-quartz w-100 mb-2" style="font-size: 15px;"  v-if="currentQuarter == selectedQuarter || selectedQuarter == 'Q4 FY26'">
                                <LanguagePlaceholder is-html
                                default-text="For more information on RISE rewards earnings and payments, " />
                                <a style='text-decoration: underline;cursor: pointer;' @click="systemStore.routerTo('home-about-rise-partner')">click here</a>
                            </div> -->
                        </div>

                        <v-expansion-panels v-model="panel2" tile variant="accordion" role="group" aria-label="Products you can spend rewards on">
                            <v-expansion-panel>

                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}" 
                                        aria-label="Expand PCS+ Displays+ Peripherals spending information"
                                        tabindex="0">
                                        <LanguagePlaceholder default-text="PCS+ DISPLAYS+ PERIPHERALS" />
                                    </v-expansion-panel-title>
                            

                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <h3 class="text-white" style="font-size: inherit; font-weight: inherit; margin: 0;">
                                                    <LanguagePlaceholder is-html default-text="Product Overview <p style=&quot;font-size: 70%&quot;>(<b>E-vouchers cannot be used for products with Snapdragon based configuration - Qualcomm</b>)</p>" v-if="isLatestQuarterLayout" />
                                                    <LanguagePlaceholder is-html default-text="Product Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD and Qualcomm-powered configurations are not eligible on PC purchases</b>)</p>" v-else/>
                                                </h3>
                                                    
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact" aria-label="PCS+ Displays+ Peripherals spending eligibility table">
                                                    <caption class="sr-only">Table showing which PCS, Displays, and Peripherals products you can spend rewards on</caption>
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="Product Type" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Transaction Type" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="Products that you can <b>SPEND</b> rewards on" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts_Spend_PCS.items" :key="i.productType + i.transactionType" v-if="isLatestQuarterLayout">
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.productType }}
                                                                <span v-if="!i.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.transactionType }}
                                                                <span v-if="!i.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.canSpend === true ? 'Yes' : 'No' }}
                                                                <span v-if="!i.canSpend" aria-label="Not eligible for spending rewards" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                        </tr>
                                                        <tr v-for="j in eligibleProducts_Spend_PCS_withAMD.items" :key="j.productType + j.transactionType" v-else>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.productType }}
                                                                <span v-if="!j.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.transactionType }}
                                                                <span v-if="!j.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.canSpend === true ? 'Yes' : 'No' }}
                                                                <span v-if="!j.canSpend" aria-label="Not eligible for spending rewards" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>

                             <v-expansion-panel>
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}" 
                                        aria-label="Expand Server+ spending information"
                                        tabindex="0">
                                        <LanguagePlaceholder default-text="Server+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >                         
                                                <h3 class="text-white" style="font-size: inherit; font-weight: inherit; margin: 0;">
                                                    <LanguagePlaceholder is-html default-text="Product Overview" v-if="isLatestQuarterLayout"/>
                                                    <LanguagePlaceholder is-html default-text="Product Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD is not eligible on Server purchases</b>)</p>" v-else/>
                                                </h3>                                
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact" aria-label="Server+ spending eligibility table">
                                                    <caption class="sr-only">Table showing which Server+ products you can spend rewards on</caption>
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="Product Type" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Transaction Type" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="Products that you can <b>SPEND</b> rewards on" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts_Spend_Server.items" :key="i.productType + i.transactionType"  v-if="isLatestQuarterLayout">
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                            {{ i.productType }}
                                                            <span v-if="!i.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.transactionType }}
                                                                <span v-if="!i.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.canSpend === true ? 'Yes' : 'No' }}
                                                                <span v-if="!i.canSpend" aria-label="Not eligible for spending rewards" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                        </tr>
                                                        <tr v-for="j in eligibleProducts_Spend_Server_withAMD.items" :key="j.productType + j.transactionType"  v-else>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                            {{ j.productType }}
                                                            <span v-if="!j.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.transactionType }}
                                                                <span v-if="!j.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.canSpend === true ? 'Yes' : 'No' }}
                                                                <span v-if="!j.canSpend" aria-label="Not eligible for spending rewards" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>

                            </v-expansion-panel>

                            <v-expansion-panel>
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}" 
                                        aria-label="Expand Storage+ spending information"
                                        tabindex="0">
                                        <LanguagePlaceholder default-text="Storage+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <h3 class="text-white" style="font-size: inherit; font-weight: inherit; margin: 0;">
                                                    <LanguagePlaceholder default-text="Product Overview" />
                                                </h3>
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact" aria-label="Storage+ spending eligibility table">
                                                    <caption class="sr-only">Table showing which Storage+ products you can spend rewards on</caption>
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="Product Type" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder default-text="Transaction Type" />
                                                            </th>
                                                            <th class="text-left" scope="col">
                                                                <LanguagePlaceholder is-html default-text="Products that you can <b>SPEND</b> rewards on" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts_Spend_Storage.items" :key="i.productType + i.transactionType" v-if="isLatestQuarterLayout">
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.productType }}
                                                                <span v-if="!i.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.transactionType }}
                                                                <span v-if="!i.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.canSpend === true ? 'Yes' : 'No' }}
                                                                <span v-if="!i.canSpend" aria-label="Not eligible for spending rewards" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                        </tr>
                                                        <tr v-for="j in eligibleProducts_Spend_Storage_withAMD.items" :key="j.productType + j.transactionType" v-else>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.productType }}
                                                                <span v-if="!j.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.transactionType }}
                                                                <span v-if="!j.canSpend" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                            <td :style="{ color: j.canSpend===true ? '#000000' : '#FF0000', fontWeight: j.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ j.canSpend === true ? 'Yes' : 'No' }}
                                                                <span v-if="!j.canSpend" aria-label="Not eligible for spending rewards" class="sr-only"> - Not eligible</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>

                        </v-expansion-panels>
                    </v-container>
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>

        <div class="bg-color-granite w-100 h-100">
            
            <div class="bg-color-cobalt tx-color-white w-100 h-100 mt-2" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 py-10 tx-color-white" :class="{'bg-color-teal-900': systemStore.systemView === 'Distributor', 'bg-color-cobalt': systemStore.systemView !== 'Distributor'}">
                    <v-col cols="9" class="d-flex flex-column justify-start w-100 pa-0 tx-font-normal tx-font-size14">  
                        <p class="font-italic">
                            <LanguagePlaceholder default-text="Please be advised that products containing Qualcomm processors are excluded from any rewards or incentives mentioned on this page." />                                    
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder is-html default-text="* Only available in CEEMETA regions (see full lists below).  Click <a href='https://dellpartnerincentives.com/resources/Dell RISE Eligible Products_CEEMETA Displays.pdf' target='_blank' class='dell-white'>here</a> for the Displays List." />                                    
                        </p>
                        <br>
                        <p>
                            Albania, Algeria, Angola, Armenia, Azerbaijan, Bahrain, Benin, Bosnia-Herzegovina, Botswana, Bulgaria, Burkina Faso, Burundi, Cameroon, Cape Verde, Central African Republic, Chad, Comoros, Congo, Cote d'Ivoire, Croatia, Czech Republic, Democratic Rep of the Congo, Djibouti, Egypt, Equatorial Guinea, Eritrea, Ethiopia, French Guiana, French Polynesia, Gabon, Gambia, Georgia, Ghana, Greece, Guadeloupe, Guinea, Guinea Bissau, Hungary, Iraq, Jordan, Kazakhstan, Kenya, Kosovo, Kuwait, Kyrgyzstan, Lebanon, Lesotho, Liberia, Libya, Macedonia, Madagascar, Malawi, Mali, Martinique, Mauritania, Mauritius, Mayotte, Moldova, Montenegro, Morocco, Mozambique, Namibia, New Caledonia, Niger, Nigeria, Oman, Poland, Qatar, Reunion, Romania, Randa, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Slovakia, Slovenia, Somalia, South Africa, Swaziland, Tajikistan, Tanzania, The French Southern Territories, Togo, Tunisia, Turkey, Turkmenistan, Uganda, Ukraine, United Arab , rates, Uzbekistan, Yemen, Zambia, Zimbabwe.
                        </p>           
                    </v-col>
                </v-row>
            </div>     
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()

const eligibleProducts = ref({})

const quarters = ref([])
const selectedQuarter = ref('')
const currentQuarter = ref('')
const isLatestQuarterLayout = computed(() =>
    selectedQuarter.value === currentQuarter.value || selectedQuarter.value === 'Q4 FY27')
const hasServerPlusProducts = computed(() =>
    ['serverPlusB2BProducts', 'serverPlusSnSProducts', 'serverPlusB2BSmartSelectionProducts', 'serverPlusB2BOnlyProducts']
        .some(key => eligibleProducts.value[key]?.length))
const allowQuarterAutoSubmit = ref(false)
const quarterMenuOpen = ref(false)

const eligibleProducts_Spend_PCS = ref(
{
    items: [
        { productType: 'Alienware (Audio & Displays)', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Laptop', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Desktop', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Precision Workstation', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Laptops', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Desktops', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Max', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Displays', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Client Peripherals', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Docking Stations', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})

const eligibleProducts_Spend_Server = ref(
{
    items: [
        { productType: 'Enterprise Peripherals', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Networking', transactionType: 'SNS Only', canSpend: true },
        { productType: 'ROK', transactionType: 'SNS Only', canSpend: true },
        { productType: 'All Servers', transactionType: 'SNS & B2B', canSpend: true },
        { productType: 'Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})

const eligibleProducts_Spend_Storage = ref(
{
    items: [
        { productType: 'All Storage', transactionType: 'SNS & B2B', canSpend: true },
        { productType: 'Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})

const eligibleProducts_Spend_PCS_withAMD = ref(
{
    items: [
        { productType: 'Alienware', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Desktops / Inspiron / Vostro', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Laptops / Inspiron / Vostro', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Premium Desktops / XPS', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Premium Laptops / XPS', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Desktops / OptiPlex', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Laptops / Latitude', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Max Desktops / Precision Workstation', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Max Laptops / Precision Workstation', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Displays', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Client Peripherals', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Docking Stations', transactionType: 'SNS Only', canSpend: true },
        { productType: 'AMD & Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})

const eligibleProducts_Spend_Server_withAMD = ref(
{
    items: [
        { productType: 'Enterprise Peripherals', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Networking', transactionType: 'SNS Only', canSpend: true },
        { productType: 'ROK', transactionType: 'SNS Only', canSpend: true },
        { productType: 'All Servers', transactionType: 'SNS & B2B', canSpend: true },
        { productType: 'AMD & Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})

const eligibleProducts_Spend_Storage_withAMD = ref(
{
    items: [
        { productType: 'All Storage', transactionType: 'SNS & B2B', canSpend: true },
        { productType: 'AMD & Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})



onMounted(() => {
  systemStore.getQuarters().then(result => {
    if (result.success) {
        quarters.value = result.quarters
                .filter(q => q.currentQuarters === true)
                .map(q => q.quarter)

        if (!quarters.value.includes('Q3 FY27')) {
            quarters.value.unshift('Q3 FY27')
        }

        if (!quarters.value.includes('Q4 FY27')) {
            quarters.value.unshift('Q4 FY27')
        }
      
      selectedQuarter.value = 'Q4 FY27'
      currentQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter
    }
    }).catch(error => {
      console.log('Eligible Product Quarter Load', error)
    })

    systemStore.getEligibleProducts('Q4 FY27').then(result => {
      if (result.success === true) {
          eligibleProducts.value = result
      } else {
          systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
      }
      // Enable auto-submit after the initial load completes to avoid double-fetching on mount.
      allowQuarterAutoSubmit.value = true
  }).catch(error => {
      systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
      allowQuarterAutoSubmit.value = true
  })

})

watch(
    selectedQuarter,
    (newQuarter, oldQuarter) => {
        if (!allowQuarterAutoSubmit.value) return
        if (!newQuarter || newQuarter === oldQuarter) return
        clickSubmit(newQuarter)
    },
    { flush: 'post' }
)

const clickSubmit = (newQuarter) => {
    // When called from `v-select`'s update event, ensure we submit using the newly selected value.
    if (typeof newQuarter === 'string' && newQuarter.length > 0) {
        selectedQuarter.value = newQuarter
    }

    if (!selectedQuarter.value) return

    systemStore.getEligibleProducts(selectedQuarter.value).then(result => {
      if (result.success === true) {
          eligibleProducts.value = result
      } else {
          systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
      }
  }).catch(error => {
      systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
  })
}

const clickDownloadSKUListForCodes = () => {
  systemStore.getFile('FY25Q3 SKU LIST for Codes_WEBFINAL.pdf', 'files').then(res => {
      if (res.success === true) {
          systemStore.openUrl(res.fileUrl)
      }
  }).catch(error => {
      console.log(error)
  })
}

const panel = ref(0)

const panel2 = ref(0)

</script>

<style scoped>

/* Screen reader only content */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Issue #34: Focus indicator for v-select and interactive elements */
:deep(.v-select:focus-within .v-field__outline),
:deep(.v-select .v-field--focused .v-field__outline) {
  box-shadow: 0 0 0 3px #0066CC !important;
}

:deep(.v-field--focused) {
  outline: 3px solid #0066CC !important;
  outline-offset: 2px !important;
}

/* WCAG 2.4.7 / 1.4.11 Focus Indicators — dual-ring: dark navy outer + white inner
   3:1+ contrast on all page backgrounds (quartz/white/blue) */
:deep(*:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

:deep(.v-btn:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

:deep(.v-expansion-panel-title:focus-visible),
:deep(.v-expansion-panel-title:focus) {
  outline: 3px solid #003785 !important;
  outline-offset: -2px !important;
  box-shadow: 0 0 0 2px #FFFFFF inset !important;
  position: relative !important;
  z-index: 10 !important;
}

:deep(.v-table th:focus-visible),
:deep(.v-table td:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: -1px !important;
  box-shadow: 0 0 0 2px #FFFFFF inset !important;
}

:deep(.v-list-item:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: -2px !important;
  background-color: rgba(0, 55, 133, 0.08) !important;
}

/* Remove mouse focus outlines */
:deep(*:focus:not(:focus-visible)) {
  outline: none !important;
}

/* High contrast mode */
@media (prefers-contrast: high) {
  :deep(*:focus-visible) {
    outline-width: 4px !important;
    outline-color: #000000 !important;
    box-shadow: 0 0 0 4px #FFFFFF !important;
  }
}

/* WCAG non-text contrast: make hover state clearly visible (>= 3:1). */
:deep(.v-expansion-panel-title:hover) {
  /* High-contrast indicator against the dark header background colors used on this page */
  box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.95) !important;
}

/* Remove Vuetify's subtle overlay on hover (often too low-contrast). */
:deep(.v-expansion-panel-title:hover .v-expansion-panel-title__overlay) {
  opacity: 0 !important;
}

/* WCAG 1.4.4 / 1.4.10 — Prevent content overlap at 200%+ zoom / 320px width */
@media (max-width: 960px) {
  :deep(.mx-10) {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  :deep(.ps-14) {
    padding-left: 0 !important;
  }
  :deep(.w-md-25) {
    width: 100% !important;
  }
}

@media (max-width: 599px) {
  :deep(.v-table) {
    display: block;
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }
  :deep(.v-expansion-panels) {
    min-width: 0;
  }
}
</style>